import { Box, Stack, Typography } from "@mui/material";
import {
  AlertTriangle as AlertTriangleIcon,
  Info as InfoIcon,
} from "react-feather";

type InfoTextProps = {
  variant: "info" | "warning" | "error";
  children: React.ReactNode;
};

type VariantConfig = {
  color: string;
  Icon: React.ElementType;
};

const variantConfigs: Record<InfoTextProps["variant"], VariantConfig> = {
  warning: {
    color: "warning.main",
    Icon: AlertTriangleIcon,
  },
  info: {
    color: "text.secondary",
    Icon: InfoIcon,
  },
  error: {
    color: "error.main",
    Icon: AlertTriangleIcon,
  },
} as const;

const InfoText = ({ variant, children }: InfoTextProps) => {
  const { color, Icon } = variantConfigs[variant];

  return (
    <Stack
      spacing={2}
      direction="row"
      alignItems="center"
      width="100%"
      p={2}
      color={color}
    >
      <Icon />
      {typeof children === "string" ? (
        <Typography variant="body2" color="inherit">
          {children}
        </Typography>
      ) : (
        <Box sx={{ flex: 1 }}>{children}</Box>
      )}
    </Stack>
  );
};

export default InfoText;
